import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './_helpers';
import { AuthGuardAdmin } from './_helpers/auth.guardadmin';
import { AuthGuardCompanyAdmin } from './_helpers/auth.guardcompanyadmin';

const routes: Routes = [
  {
    path: 'mycard/:csr',
    loadChildren: () => import('./global-profile/global-profile.module').then(m => m.GlobalProfileModule)
  },
  {
    path: '',
    loadChildren: () => import('./default/default.module').then(m => m.DefaultModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'register/:csr',
    loadChildren: () => import('./register/register.module').then(m => m.RegisterModule)
  },
  {
    path: 'account-confirmation/:token',
    loadChildren: () => import('./account-confirmation/account-confirmation.module').then(m => m.AccountConfirmationModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./terms/terms.module').then(m => m.TermsModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'reset-password/:token',
    loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule)
  },
  {
    path: 'admin',
    canActivate: [AuthGuardAdmin],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'company-master',
    canActivate: [AuthGuardAdmin],
    loadChildren: () => import('./company-master/company-master.module').then(m => m.CompanyMasterModule)
  },
  {
    path: 'company-admin',
    canActivate: [AuthGuardCompanyAdmin],
    loadChildren: () => import('./company-user/company-user.module').then(m => m.CompanyUserModule)
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  },
  //otherwise redirect to home
  { path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
